import { LucideIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface EmptyStateProps {
    icon: LucideIcon;
    title: string;
    description: string;
    actionLabel?: string;
    actionPath?: string;
}

export default function EmptyState({ icon: Icon, title, description, actionLabel, actionPath }: EmptyStateProps) {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col items-center justify-center py-20 px-4 text-center animate-in fade-in slide-in-from-bottom-4 duration-700">
            <div className="bg-dark-surface p-6 rounded-3xl border border-dark-border mb-6 shadow-xl shadow-accent-purple/5">
                <Icon size={48} className="text-accent-purple/50" />
            </div>
            <h3 className="text-xl font-bold mb-2 tracking-tight">{title}</h3>
            <p className="text-dark-muted max-w-xs mb-8 text-sm leading-relaxed">
                {description}
            </p>
            {actionLabel && actionPath && (
                <button
                    onClick={() => navigate(actionPath)}
                    className="bg-accent-purple hover:bg-accent-purple-hover text-white px-8 py-3 rounded-2xl font-bold transition-all hover:scale-105 active:scale-95 shadow-lg shadow-accent-purple/20"
                >
                    {actionLabel}
                </button>
            )}
        </div>
    );
}
